const KEY = "magit-cookie-consent";
const EVENT = "magit-open-cookie-banner";

export const getConsent = () => localStorage.getItem(KEY);

export const setConsent = (value) => {
  const previous = getConsent();
  localStorage.setItem(KEY, value);
  if (value === "granted") {
    window.magitLoadAnalytics?.();
  } else if (previous === "granted") {
    window.posthog?.opt_out_capturing?.();
    window.location.reload();
  }
};

export const openCookieBanner = () => window.dispatchEvent(new Event(EVENT));

export const onOpenCookieBanner = (fn) => {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
};
